import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import {
  JourneyViewListCardEmptyState,
  JourneyViewListCardEmptyStateProps,
} from '@/features/journey/admin/atoms/JourneyViewListCardEmptyState';
import { JourneyViewListCardActionsBar } from '@/features/journey/admin/atoms/JourneyViewListCardActionsBar';
import { Skeleton } from '@/ui/Skeleton';
import { makeNamespacedComponent } from '@/ui/utils';

const RootStyled = styled.div<{ bordered?: boolean }>`
  ${({ bordered }) =>
    bordered &&
    css`
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
    `}
`;

const ContentStyled = styled.div`
  padding: 0 0 32px 0;
`;

type JourneyViewListCardProps = {
  emptyProps: JourneyViewListCardEmptyStateProps;
  itemsCount?: number;
  title?: string;
  onEditClick?: () => void;
  onViewClick?: () => void;
  children: ReactNode;
  className?: string;
  styleBordered?: boolean;
};

const JourneyViewListCard = ({
  emptyProps,
  itemsCount,
  title,
  children,
  className,
  onEditClick,
  onViewClick,
  styleBordered,
}: JourneyViewListCardProps): JSX.Element => {
  return (
    <RootStyled className={className} bordered={styleBordered}>
      {!React.Children.count(children) ? (
        <>
          <JourneyViewListCardActionsBar title={title} count={itemsCount} minimized={!styleBordered} />
          <ContentStyled>
            <JourneyViewListCardEmptyState {...emptyProps} minimized={!styleBordered} />
          </ContentStyled>
        </>
      ) : (
        <>
          <JourneyViewListCardActionsBar
            title={title}
            count={itemsCount}
            minimized={!styleBordered}
            onEditClick={onEditClick}
            onViewClick={onViewClick}
          />
          <ContentStyled>{children}</ContentStyled>
        </>
      )}
    </RootStyled>
  );
};

const LoadingState = () => <Skeleton height={560} />;

const _JourneyViewListCard = makeNamespacedComponent(JourneyViewListCard, {
  LoadingState,
});

export { _JourneyViewListCard as JourneyViewListCard };
